import { createFileRoute, notFound } from "@tanstack/react-router";
import { ServiceDetailPage } from "@/components/sections/service-detail";
import { LEAD_GEN_SERVICES, RELATED_LEAD_GEN } from "@/lib/marketing-services";
import { buildServiceHead } from "@/lib/service-seo";

export const Route = createFileRoute("/marketing/lead-generation/$slug")({
  component: LeadGenServicePage,
  loader: ({ params }) => {
    const detail = LEAD_GEN_SERVICES.find((s) => s.slug === params.slug);
    if (!detail) throw notFound();
    return { detail };
  },
  head: ({ loaderData }) =>
    buildServiceHead(loaderData?.detail, {
      label: "Lead Generation",
      basePath: "/marketing/lead-generation",
    }),
});

function LeadGenServicePage() {
  const { detail } = Route.useLoaderData();
  return (
    <ServiceDetailPage
      detail={detail}
      categoryLabel="Lead Generation"
      categoryHref="/marketing/lead-generation"
      related={RELATED_LEAD_GEN}
    />
  );
}
